import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { message, Popconfirm, Table, Tooltip, Divider } from 'antd'
import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faTasks } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import Pagination from '../../../components/Pagination'
import TaskResponseTasksModal from './TaskResponseTasksModal'

import { deleteTaskResponse } from '../services'
import { handleError } from '../../../helpers'

export default function TaskResponsesTable({ taskResponses, reload, pagination, setPagination }) {
	const user = useSelector(state => state.auth.user)
	const [taskResponseTasksModal, setTaskResponseTasksModal] = useState(null)

	const handleDelete = id => {
		deleteTaskResponse(id)
			.then(() => {
				message.success('Listado elimiando exitosamente')
				reload()
			})
			.catch(error => handleError(error))
	}

	const columns = [
		{
			title: 'ID Respuesta',
			dataIndex: 'id',
			render: t => `TR0${t}`
		},
		{
			title: 'Nombre del Checklist',
			dataIndex: 'task_list',
			render: t => t.name
		},
		{
			title: 'Punto de Venta',
			dataIndex: 'store',
			render: t => t?.name || <em>Sin registro</em>
		},
		{
			title: 'Respuestas Registradas',
			dataIndex: 'tasks',
			render: t => `${t.length} respuestas`
		},
		{
			title: 'Registrado por',
			dataIndex: 'user',
			render: t => t.name
		},
		{
			title: 'Registrado el',
			dataIndex: 'created_at',
			render: t => moment(t).format('YYYY-MMM-DD hh:mm A')
		},
		{
			title: 'Fecha Última Actualización',
			dataIndex: 'updated_at',
			render: t => moment(t).format('YYYY-MMM-DD hh:mm A')
		},
		{
			title: 'Acciones',
			width: 120,
			render: (t, record) => (
				<React.Fragment>
					<Tooltip title="Ver respuestas">
						<Button color="primary" size="sm" outline onClick={() => setTaskResponseTasksModal(record)}>
							<FontAwesomeIcon icon={faTasks} />
						</Button>
					</Tooltip>
					<Divider type="vertical" />
					{ user.ranking === 'admin' && (
						<Popconfirm
							title="¿Seguro desea eliminarla?"
							okText="Eliminar"
							cancelText="Cancelar"
							onConfirm={() => handleDelete(record.id)}
							okButtonProps={{ danger: true }}
						>
							<Tooltip title="Eliminar">
								<Button color="primary" size="sm" outline>
									<FontAwesomeIcon icon={faTrash} />
								</Button>
							</Tooltip>
						</Popconfirm> 
					)}
				</React.Fragment>
			)
		}
	]

	return (
		<React.Fragment>
			<Table 
				dataSource={taskResponses}
				rowKey={record => record.id}
				columns={columns}
				pagination={false}
				expandable={{ 
					expandedRowRender: record => (
						<React.Fragment>
							{ record.tasks.map(task => (
								<p key={task.id}>
									<strong>{task.task_template.name}: </strong>
									{task.comment}
								</p>
							)) }
						</React.Fragment>
					)
				}}
			/>
			<Pagination 
				reload={reload}
				pagination={pagination}
				updatePagination={setPagination}		
			/>
			{ taskResponseTasksModal && (
				<TaskResponseTasksModal
					visible
					onClose={() => setTaskResponseTasksModal(null)}
					tasks={taskResponseTasksModal.tasks}
				/>
			)}
		</React.Fragment>
	)
}